import React from 'react';
import clsx from 'clsx';
import type { PaperProps } from './Paper.types';

/**
 * A component for wrapping content in a presentational container. Themeable and
 * requires the application of a global or local theme.
 */
export const Paper = React.forwardRef<HTMLElement, PaperProps>(
  (
    {
      as: Component = 'div',
      children,
      theme,
      isFluid,
      className,
      testId,
      ...restProps
    },
    ref
  ) => {
    return (
      <Component
        ref={ref}
        className={clsx('hg-paper', { 'hg-paper--fluid': isFluid }, className)}
        data-theme={theme}
        data-testid={testId}
        {...restProps}
      >
        {children}
      </Component>
    );
  }
);
